import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import * as inspectionDefectCrud from '../../../../crud/inspectionDefect.crud';
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import { connect } from "react-redux";
import Common from '../../../../shared/common';
import DataSource from 'devextreme/data/data_source';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, partyDataSource) => {
    const formFields = [];

    if (fields.Subject.visible) {
        formFields.push({
            caption: fields.Subject.label,
            dataField: 'assistancetestserchdefect',
            required: fields.Subject.required,
            dataType: 'string',
        })
    }

    if (fields.Details.visible) {
        formFields.push({
            caption: fields.Details.label,
            dataField: 'inspectiondetails',
            required: fields.Details.required,
            dataType: 'long-string',
        })
    }

    if (fields.DelegatedTo.visible) {
        formFields.push({
            caption: fields.DelegatedTo.label,
            dataField: 'replyactiondetail',
            required: fields.DelegatedTo.required,
            dataType: 'integer'
        })
    }

    if (fields.StartDate.visible) {
        formFields.push({
            caption: fields.StartDate.label,
            dataField: 'inspectiondatedisplay',
            required: fields.StartDate.required,
            dataType: 'date',
        })
    }

    if (fields.EndDate.visible) {
        formFields.push({
            caption: fields.EndDate.label,
            dataField: 'inspectiontime',
            required: fields.EndDate.required,
            dataType: 'date',
        })
    }

    return formFields;
}

class ActionListPage extends BaseListPage {
    constructor(props) {
        super(props);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }

        var partyDataSource = this.getPartyDataSource();

        this.batchFormFields = getBatchFormFields(props.workflowItem.fields, partyDataSource);

        this.state = {
            notifications: null,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchNotifications();
    }

    fetchNotifications = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await inspectionDefectCrud.getContractInspections(companyid, projectid, contractid, this.props.notificationType, this.props.accessibleWfIds);
            let listData = notificationAggregateListTagsFilter(JSON.parse(responseObj.aggregatelist));
            listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
                listData :
                listData.filter(ntf => ntf.showtasknotification === 1);

            let tagFilters = notificationUniqueTagsFilter(JSON.parse(responseObj.uniquetags));

            this.setState({ notifications: listData, tags: tagFilters });
        } catch (error) {
            console.log(error);
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }

    }

    getPartyDataSource = () => {
        if (this.props.contractUsers) {
            if (this.props.allowCrossPartyDelegationsIsEnabled) {
                const mappedContractUsers = this.props.contractUsers.map(x => ({
                    userid: x.accountid,
                    user: x.user,
                    party: Common.GetPartyDisplay(x.usergroup, this.props.globalResources)
                }));
                const groupedUserList = new DataSource({
                    store: {
                        type: 'array',
                        data: mappedContractUsers,
                        key: 'userid'
                    },
                    group: 'party'
                });
                return groupedUserList;
            }
            else {
                const mappedContractUsers = this.props.contractUsers.filter(user => user.usergroup === this.props.delegationUserParty).map(x => ({
                    userid: x.accountid,
                    user: x.user
                }))
                return mappedContractUsers;
            }
        }
        return null;
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.inspectiondefectid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = cellInfo.data.showtasknotification === 1 ? 'success' : 'secondary';
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.replystatus });
    }
    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: "assistancetestserchdefect" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "replystatus", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },

        ];
        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={inspectionDefectCrud.importInspectionDefects}
                        batchDeleteEndpoint={inspectionDefectCrud.deleteInspectionDefectDrafts}
                        batchCommunicateEndpoint={inspectionDefectCrud.communicateInspectionDefectDrafts}
                        onBatchRecordsUpdated={this.fetchNotifications}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="inspectiondefectid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contractUsers: store.contract.users
});

export default withListPageProps(connect(mapStateToProps)(ActionListPage));